﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global } from "../Common/saop-common";
import { SaopServicesCore } from "../Core/saop-services-core";
import { SaopRightSidebar } from '../Components/saop-right-sidebar';
import { SaopRegAbsenceEventsView } from '../REG/saop-regAbsenceEvents-view';
import { SaopMessageBanner } from '../Components/saop-message-banner';

export class DashboardAbsencesView {
    private _libName:string;
    private _saopServicesCore :SaopServicesCore;
    //
    public regAbsenceEventsView:SaopRegAbsenceEventsView;
    private saopMessageBanner: SaopMessageBanner;

    constructor(libName: string = "") {
        this._libName = libName;
        //
        this._saopServicesCore = new SaopServicesCore();
        this.regAbsenceEventsView = new SaopRegAbsenceEventsView("#regKeZapDopustiView0",libName+".regAbsenceEventsView");
        this.regAbsenceEventsView.refreshData = this.refreshGridData.bind(this);
        this.saopMessageBanner = new SaopMessageBanner();
    }

    refreshGridData(): void {
        global.ConsoleLogDegug("DashboardCard2.refreshGridData");
        let _this = this;
        this._saopServicesCore.afterDone = function(response){
            $("#card2 .card-body").html(response);
            _this.regAbsenceEventsView.bindGridEvents();
            _this.handleBannerMessages();
        };
        this._saopServicesCore.ExecuteAction({
            action:"Dashboard/AbsencePartial"
            ,type:"GET"
            ,spinnerDivId:"#saopLoadingcard2"
        });   

        let _saopRightSidebar: SaopRightSidebar = new SaopRightSidebar();
        _saopRightSidebar.refreshDopustZaKoriscenjeSummary("#dopustZaKoriscenjeSummary");
        
        let _saopRightSidebarUre: SaopRightSidebar = new SaopRightSidebar();
        _saopRightSidebarUre.refreshUreZaKoriscenjeSummary("#ureZaKoriscenjeSummary");
    } 
    private handleBannerMessages(): void {
        const bannerDiv = $("#hiddenBannerData");
        if (bannerDiv.length > 0) {
            const rawData = bannerDiv.data("banner");
   
            if (rawData && rawData.Messages && rawData.Messages.length) {
                const messages: string[] = [ rawData.Messages.toString() ];
                this.saopMessageBanner.show(messages);
            }
        }
    }
   
    //
}


